import { Box } from '@mui/material'
import { Colors } from 'components/Theme'
import { type SweepstakeStatusType } from 'types/api'

const sweepstakeStatusString: Record<SweepstakeStatusType, string> = {
  Draft: 'Draft',
  Enrollable: 'Enrollable',
  EnrollmentClosed: 'Enrollment Closed',
  Live: 'Live',
  InternalValidation: 'Internal Validation',
  WinnerValidation: 'Winner Validation',
  Closed: 'Closed',
}

const getStatusColor = (status: SweepstakeStatusType) => {
  return Colors.sweepstakesStatus.background[status]
}

const getStatusTextColor = (status: SweepstakeStatusType) => {
  return Colors.sweepstakesStatus.text[status]
}

export const SweepstakesStatusLabel = ({
  status,
}: {
  status: SweepstakeStatusType
}) => {
  return (
    <Box
      className="px-2 pt-1 pb-0.5 rounded-sm font-bold uppercase"
      sx={{
        backgroundColor: getStatusColor(status),
        color: getStatusTextColor(status),
      }}
    >
      {sweepstakeStatusString[status]}
    </Box>
  )
}
